import moment from 'moment';
import getCurrentTimezoneOffset from './getCurrentTimezoneOffset';

export default function formatIsoString(str){
    return moment.utc(str).add(getCurrentTimezoneOffset(), 'minute').format("HH:mm");
}